import React from 'react';
import { Row, Skeleton, Divider } from 'antd';

const TransactionListSkeleton = ({ active = true }) => {
  return (
    <div className="transaction-list-skeleton">
      <Row
        justify="space-between"
        align="middle"
        className="transaction-list-skeleton__top-row"
      >
        <Skeleton.Button active={active} style={{ width: 100 }} />
        <Skeleton.Button active={active} style={{ width: 100 }} />
      </Row>
      <Row justify="space-between" align="middle">
        <Skeleton.Button active={active} style={{ width: 150 }} />
        <Skeleton.Button active={active} style={{ width: 150 }} />
      </Row>
      <Divider />
      <Row
        justify="space-between"
        align="middle"
        className="transaction-list-skeleton__top-row"
      >
        <Skeleton.Button active={active} style={{ width: 100 }} />
        <Skeleton.Button active={active} style={{ width: 100 }} />
      </Row>
      <Row justify="space-between" align="middle">
        <Skeleton.Button active={active} style={{ width: 150 }} />
        <Skeleton.Button active={active} style={{ width: 150 }} />
      </Row>
      <Divider />
      <Row
        justify="space-between"
        align="middle"
        className="transaction-list-skeleton__top-row"
      >
        <Skeleton.Button active={active} style={{ width: 100 }} />
        <Skeleton.Button active={active} style={{ width: 100 }} />
      </Row>
      <Row justify="space-between" align="middle">
        <Skeleton.Button active={active} style={{ width: 150 }} />
        <Skeleton.Button active={active} style={{ width: 150 }} />
      </Row>
      <Divider />
      <Row
        justify="space-between"
        align="middle"
        className="transaction-list-skeleton__top-row"
      >
        <Skeleton.Button active={active} style={{ width: 100 }} />
        <Skeleton.Button active={active} style={{ width: 100 }} />
      </Row>
      <Row justify="space-between" align="middle">
        <Skeleton.Button active={active} style={{ width: 150 }} />
        <Skeleton.Button active={active} style={{ width: 150 }} />
      </Row>
      <Divider />
      <Row
        justify="space-between"
        align="middle"
        className="transaction-list-skeleton__top-row"
      >
        <Skeleton.Button active={active} style={{ width: 100 }} />
        <Skeleton.Button active={active} style={{ width: 100 }} />
      </Row>
      <Row justify="space-between" align="middle">
        <Skeleton.Button active={active} style={{ width: 150 }} />
        <Skeleton.Button active={active} style={{ width: 150 }} />
      </Row>
      <Divider />
    </div>
  );
};

export default TransactionListSkeleton;
